/* eslint-disable */
import { Autocomplete, TextField, Checkbox } from '@mui/material';
import { Check } from 'lucide-react';

// Reusable searchable store picker (single or multi). Replaces the bare/comma
// Select used earlier. `value` is a store id (single) or an array of ids (multi).
const StorePicker = ({
	stores = [],
	value,
	onChange,
	multiple = false,
	label = 'Store',
	placeholder,
	helperText,
	disabled = false,
}) => {
	const options = stores || [];

	if (multiple) {
		const selected = options.filter((s) => (value || []).includes(s.id));
		return (
			<Autocomplete
				multiple
				size='small'
				disableCloseOnSelect
				disabled={disabled}
				options={options}
				value={selected}
				getOptionLabel={(o) => o?.name || `#${o?.id}`}
				isOptionEqualToValue={(o, v) => o.id === v.id}
				onChange={(_e, val) => onChange((val || []).map((v) => v.id))}
				renderOption={(props, option, { selected: isSel }) => (
					<li {...props} key={option.id}>
						<Checkbox
							size='small'
							icon={<span style={{ width: 16 }} />}
							checkedIcon={<Check size={16} />}
							checked={isSel}
							sx={{ p: 0.5, mr: 1 }}
						/>
						{option.name || `#${option.id}`}
					</li>
				)}
				renderInput={(params) => (
					<TextField
						{...params}
						label={label}
						placeholder={placeholder || 'Search stores…'}
						helperText={helperText}
					/>
				)}
			/>
		);
	}

	const single = options.find((s) => s.id === value) || null;
	return (
		<Autocomplete
			size='small'
			disabled={disabled}
			options={options}
			value={single}
			getOptionLabel={(o) => o?.name || `#${o?.id}`}
			isOptionEqualToValue={(o, v) => o.id === v.id}
			onChange={(_e, val) => onChange(val ? val.id : '')}
			renderOption={(props, option) => (
				<li {...props} key={option.id}>
					{option.name || `#${option.id}`}
				</li>
			)}
			renderInput={(params) => (
				<TextField
					{...params}
					label={label}
					placeholder={placeholder || 'Search store…'}
					helperText={helperText}
				/>
			)}
		/>
	);
};

export default StorePicker;
